import { useMemo } from "react";
import usePlanDetailsV2 from "./usePlanDetailsV2";
export default function useGetPlanAccountDetails(planId, accountId, config) {
    const planDetails = usePlanDetailsV2(planId, config);
    return useMemo(() => {
        if (planDetails.isLoading) {
            return { isLoading: true, hasError: false, data: undefined };
        }
        if (planDetails.hasError) {
            return {
                hasError: true,
                error: planDetails.error,
                isLoading: false,
                data: undefined,
            };
        }
        const account = planDetails.data.resources.accounts.find((account) => account.virtualAccountId === accountId);
        if (account === undefined) {
            return {
                hasError: true,
                error: new Error("Account not found."),
                isLoading: false,
                data: undefined,
            };
        }
        return { data: account, isLoading: false, hasError: false };
    }, [accountId, planDetails]);
}
//# sourceMappingURL=useGetPlanAccountDetails.js.map